module.exports = __webpack_public_path__ + "static/media/Flaticon2.4248a892.svg";